import { useQuery } from "@tanstack/react-query";
import { queryCommonFlags } from "@/api/constants";
import { LeadSale } from "@/modules/lead-page/types";
import { useContext } from "react";
import { LeadPageContext } from "../context/lead-page.context";
import type { SalesResponseV2 } from "@/modules/sales/dtos";
import { getLeadSales } from "@/modules/leads/api/index.v2";

const useGetLeadSales = ({ enabled = true }: { enabled?: boolean } = {}) => {
  const { lead } = useContext(LeadPageContext);

  const {
    data: LeadSalesData,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["getLeadSales", lead?.data?.lead?.uid],
    queryFn: () => getLeadSales(lead?.data?.lead?.uid),
    ...queryCommonFlags,
    enabled: enabled,
  });

  let leadSales: LeadSale[] = [];
  let noSales = false;

  if (LeadSalesData?.data) {
    if (LeadSalesData?.data.length > 0) {
      leadSales = LeadSalesData.data.map((sale: SalesResponseV2) => ({
        id: sale?.id ?? "N/A",
        oldId: sale?.oldId,
        property_type: sale?.propertyType?.name ?? "N/A",
        unit_value: sale?.unitValue ?? "N/A",
        compound: sale?.compound?.name ?? "N/A",
        developer: sale?.developer?.name ?? "N/A",
        date_of_reservation: sale?.dateOfReservation ?? "N/A",
        actual_value: sale?.actualValue ?? "N/A",
        sales_agent: sale?.agent?.name ?? "N/A",
        sale_category: sale?.saleCategory ?? "N/A",
        unit_number: sale?.unitNumber ?? "N/A",
        unit_location: sale?.area?.name ?? "N/A",

        date_of_contraction: sale?.dateOfContraction ?? "N/A",
        linked_sale_type: sale?.linkedSaleType ?? "N/A",
        sales_type: sale?.saleType?.name ?? "N/A",
      }));
    } else {
      noSales = true;
    }
  }

  return { leadSales, isLoading, isError, noSales };
};

export default useGetLeadSales;
